import { useState } from 'react'
import { useCurrency, shortPrice } from './shared'
import { t } from '../../../i18n'

const NEON = ['#ff3ea5', '#22d3ee', '#a3e635', '#fbbf24', '#c084fc']

// Bar drinks board: a neon sign up top, glowing category buttons on the
// left (chips on mobile), and only the selected category's list on the
// right - fast to scan in a dark room.
export default function BarTemplate({ menu, table, addItem, onSelectItem }) {
  const currency = useCurrency()
  const categories = menu.filter(c => c.items?.length)
  const [activeIndex, setActiveIndex] = useState(0)
  const active = categories[activeIndex] || categories[0]
  const glow = NEON[activeIndex % NEON.length]

  return (
    <div className="max-w-6xl mx-auto rounded-3xl bg-[#0a0a0f] text-white p-5 md:p-10" style={{ fontFamily: "'Futura', 'Trebuchet MS', sans-serif" }}>
      <header className="text-center mb-10">
        <h1 className="text-5xl md:text-7xl font-black uppercase tracking-wider" style={{ color: '#fff', textShadow: `0 0 8px ${glow}, 0 0 24px ${glow}, 0 0 48px ${glow}` }}>{t("Open late")}</h1>
        <p className="text-white/50 tracking-[0.4em] text-xs mt-4">{table ? t("TABLE {table} · ", { table: table }) : ''}{t("CHOOSE YOUR POISON")}</p>
      </header>

      <div className="grid grid-cols-1 md:grid-cols-[240px_minmax(0,1fr)] gap-6 md:gap-10">
        <nav className="min-w-0 flex md:flex-col gap-2 overflow-x-auto no-scrollbar" aria-label={t("Drink categories")}>
          {categories.map((c, i) => {
            const color = NEON[i % NEON.length]
            const on = i === activeIndex
            return (
              <button key={c.id} onClick={() => setActiveIndex(i)} aria-pressed={on}
                className="shrink-0 text-start px-5 py-3 rounded-xl border-2 font-bold uppercase tracking-wider text-sm transition-all"
                style={{ borderColor: on ? color : 'rgba(255,255,255,0.12)', color: on ? '#fff' : 'rgba(255,255,255,0.6)', boxShadow: on ? `0 0 16px ${color}80, inset 0 0 12px ${color}40` : 'none' }}>
                {c.name}<span className="ms-2 opacity-50 text-xs">{c.items.length}</span>
              </button>
            )
          })}
        </nav>

        {active && (
          <section className="min-w-0 rounded-2xl border p-5 md:p-8" style={{ borderColor: `${glow}66`, boxShadow: `0 0 30px ${glow}22` }}>
            <h2 className="text-3xl font-black uppercase mb-6" style={{ color: glow }}>{active.name}</h2>
            <ul className="divide-y divide-white/10">
              {active.items.map(item => (
                <li key={item.id} className="py-4 flex items-center gap-4">
                  {item.image && <img loading="lazy" src={item.image} alt="" className="w-14 h-14 rounded-lg object-cover shrink-0" onError={e => { e.currentTarget.style.display = 'none' }} />}
                  <button onClick={() => onSelectItem(item)} className="flex-1 min-w-0 text-start">
                    <h3 className="text-lg font-bold">{item.name}</h3>
                    {item.description && <p className="text-sm text-white/50 line-clamp-1">{t(item.description)}</p>}
                  </button>
                  <span className="text-xl font-black whitespace-nowrap" style={{ color: glow }}>{shortPrice(item.price)}<span className="text-xs text-white/40 ms-1">{currency}</span></span>
                  <button onClick={() => addItem(item)} aria-label={t("Add {name}", { name: item.name })} className="w-10 h-10 rounded-full border-2 text-xl font-black shrink-0 hover:bg-white hover:text-black transition-colors" style={{ borderColor: glow, color: glow }}>+</button>
                </li>
              ))}
            </ul>
          </section>
        )}
      </div>
    </div>
  )
}
